/**
 * In The Works (parking lot) layout.
 *
 * The grid track must include: 1px left border + room for a vertical scrollbar (~8px) +
 * 10px + 320px (card) + 10px, so the scroll client width stays ≥340px and rows stay 320px.
 * Keep Roadmap/Row `min-width` rules in sync with `PARKING_LOT_GRID_COLUMN_PX`.
 */
export const PARKING_LOT_CONTENT_PADDING_X_PX = 10;

export const PARKING_LOT_CARD_WIDTH_PX = 320;

/** `ParkingLot.module.scss` webkit scrollbar; reserve so cards are not squashed. */
export const PARKING_LOT_SCROLLBAR_RESERVE_PX = 8;

/**
 * 1 (border) + {@link PARKING_LOT_SCROLLBAR_RESERVE_PX} + 2× padding + card width
 */
export const PARKING_LOT_GRID_COLUMN_PX =
  1 +
  PARKING_LOT_SCROLLBAR_RESERVE_PX +
  2 * PARKING_LOT_CONTENT_PADDING_X_PX +
  PARKING_LOT_CARD_WIDTH_PX; // 349

/** Matches `TimelineCard.module.scss` `.container.compact` / `.content.compactContent` (36px). */
export const PARKING_LOT_CARD_HEIGHT_PX = 36;

/** Same as `TimelineCard.module.scss` `.dateContainer` `width` (60px). */
export const PARKING_LOT_DATE_STRIP_WIDTH_PX = 60;
